const Disclaimer = () => (
  <div className="container Padding-Top">
    <h1>Disclaimer</h1>
    <p>
      The information provided on this wholesale website is intended for general information 
      regarding our sarees, lehengas, readymade garments, gowns, and related wholesale products. 
      While we strive to keep all details, prices, and product descriptions accurate and up to date, 
      we do not guarantee the completeness, reliability, or accuracy of any information displayed.
    </p>

    <p>
      Product images are for illustrative purposes only and may differ slightly from the actual product 
      due to lighting, photography, or variations in fabric and design. Prices, stock availability, and offers 
      are subject to change without prior notice.
    </p>

    <p>
      This website is intended for wholesale buyers only. Any misuse of the website, including 
      unauthorized reproduction of content, product images, or designs, is strictly prohibited.
    </p>

    <p>
      We shall not be held liable for any direct, indirect, incidental, or consequential loss or damage 
      arising from the use of this website, including but not limited to delays in order processing, 
      incorrect product information, or third-party service interruptions. 
      Your use of this site and reliance on its information is entirely at your own risk.
    </p>

    <p>
      For any questions, please contact us at&nbsp; 
      <a href="mailto:info@hs-india.com">info@hs-india.com</a>.
    </p>
  </div>
);

export default Disclaimer;